<div class="shop-page">
  <!-- Page Header -->
  <div class="shop-header">
    <div class="container">
      <span class="page-label">{{ 'shop.label' | translate }}</span>
      <h1 class="page-title">{{ 'shop.title' | translate }}</h1>
      <p class="page-sub">{{ 'shop.sub' | translate }}</p>
    </div>
  </div>

  <div class="container shop-body">

    <!-- Loader -->
    <div class="loader-container" *ngIf="isLoading">
      <div class="lux-loader">
        <div class="lux-loader-ring"></div>
      </div>
    </div>

    <!-- Product Grid -->
    <div class="prod-grid" *ngIf="!isLoading">
      <div
        class="prod-card"
        (click)="productDetails(item)"
        *ngFor="let item of products | paginate: { itemsPerPage: 20, currentPage: page, totalItems: totalCount }"
      >
        <figure class="prod-figure">
          <img [src]="item.images[0].image_url" [alt]="item.name" loading="lazy" />
          <span class="prod-badge" *ngIf="item.discount > 0">{{ item.discount }}% OFF</span>
          <div class="prod-overlay">
            <span class="prod-cta">{{ 'shop.view' | translate }}</span>
          </div>
        </figure>
        <div class="prod-info">
          <h5 class="prod-name text-truncate">{{ getLangName(item) }}</h5>
          <div class="prod-rating">
            <ng-container *ngFor="let r of item.rating_arr">
              <i class="ti-star rated"></i>
            </ng-container>
            <ng-container *ngIf="item.rating_arr.length === 0">
              <i class="ti-star"></i>
              <i class="ti-star"></i>
              <i class="ti-star"></i>
              <i class="ti-star"></i>
              <i class="ti-star"></i>
            </ng-container>
          </div>
          <div class="prod-price-group">
            <span class="prod-price-was" *ngIf="item.discount > 0">LE {{ item.price }}</span>
            <p class="prod-price">LE {{ effectivePrice(item) }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="lux-pagination" *ngIf="!isLoading">
      <pagination-controls
        (pageChange)="pageChanged($event)"
      ></pagination-controls>
    </div>

  </div>
</div>
